export const selectOptionsAmortizationType = [
  "30-Year Fixed",
  "Interest Only",
  "10yr IO, 20-Year Amortizing",
];
